<template>
  <div v-if="files && files.length">
    <div v-for="file in files" :key="file.name">
      <a :href="file.url" target="_blank" download>
        {{ file.name }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-file-link-list',

  props: {
    files: Array,
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/shared/file/file-link-list.vue?6f070949